import { render, staticRenderFns } from "./PopupEditProfile.vue?vue&type=template&id=94b5b392&"
import script from "./PopupEditProfile.vue?vue&type=script&lang=js&"
export * from "./PopupEditProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports